<template>
  <v-dialog
    v-model="dialog"
    :width="step == 0? '510px': '330px'">
    <div class="dialog-container">
      <template v-if="step == 0">
        <h3>Mark As Issuing</h3>
        <p>This policy will no longer be adjustable. Continue?</p>

        <el-form
          v-if="form.product_id == 11"
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>Cover Note(Optional)</span>
            <file-container
              :fileData="formData.cvr_pdf"
              :edit="true"
              titleName= "Cover Note(Optional)"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
          </div>
          <div
            v-if="formData.cvr_pdf"
            class="form-item">
            <span>Cover Note No.</span>
            <el-form-item
              ref="cvr_nt_no"
              prop="cvr_nt_no">
              <v-input v-model="formData.cvr_nt_no" />
            </el-form-item>

          </div>
        </el-form>

        <div class="dialog-footer">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="onContinue">Continue</v-button>
        </div>
      </template>
      <template v-else>
        <!-- <el-form
          ref="send-form"
          :rules="rules"
          :model="sendFormData">
          <h3>Send Email/SMS</h3>
          <div class="form-item">
            <span>Customer</span>
            <div>
              <span v-if="form.cust_typ == 1">{{ form.customer? form.customer.isrd_nm: '' }} {{ ` - ${form.mobile_no}` }}</span>
              <span v-else>{{ form.contact_nm }} - {{ from.contact_phone }}</span>
            </div>
          </div>
          <div class="form-item">
            <span>Content</span>
            <el-form-item prop="content">
              <v-input
                v-model="sendFormData.content"
                type="textarea"
                :rows="4" />
            </el-form-item>
          </div>
        </el-form>
        <div class="flex-sb-center">
          <div>
            <v-button @click="dialog = false">Cancel</v-button>
          </div>
          <div>
            <v-button @click="onSkip">Skip</v-button>
            <v-button
              type="success"
              @click="onSend">Send</v-button>
          </div>
        </div> -->

        <send-email-sms
          ref="send-email-sms"
          :form="form"
          :initContent="form.cover_note_url_data"
          :emailListTitle="emailListTitle"
          :emailTitle="emailTitle"
          :orderId="orderId"
          @cancel="dialog = false"
          @send="onSend"
          @skip="onSkip" />
      </template>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {
  orderIssueIssuing,
  sendOrderIssueIssuingNotice } from '@/api/order'
import SendEmailSms from './send-email-sms'

export default {
  name: 'MarkAsIssuingDialog',
  components: {
    SendEmailSms
  },
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      step: 0,
      formData: {
        cvr_nt_no: '',
        cvr_pdf_path_id: '',
        cvr_pdf_path: '',
        cvr_pdf: null,
      },
      sendFormData: {
        content: ''
      }
    }
  },
  computed:{
    emailListTitle(){
      return this.form.cover_note_url_list_title || ''
    },
    emailTitle(){
      return this.form.cover_note_url_title || ''
    },
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          const { cvr_nt_no } = this.form
          const { file } = this.changeUploadData
          const {path,id} = file||{}
          this.formData.cvr_pdf = file
          this.formData.cvr_pdf_path_id = id
          this.formData.cvr_pdf_path = path
          if(cvr_nt_no) {
            this.formData.cvr_nt_no = cvr_nt_no
          }
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.step = 0
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result }) {
      this.$set(this.formData, 'cvr_pdf', data)
      this.$set(this.formData, 'cvr_pdf_path_id', data.id)
      this.$set(this.formData, 'cvr_pdf_path', data.path)
    },
    handlerDeleteFile() {
      this.$set(this.formData, 'cvr_pdf', null)
      this.$set(this.formData, 'cvr_pdf_path_id', '')
      this.$set(this.formData, 'cvr_pdf_path', '')
    },
    onContinue() {
      if(this.form.product_id != 11) {
        // this.step = 1
        this.onSkip()
        return
      }
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          //   this.network().orderIssueIssuing()
          this.step = 1
        }
        else {
          console.log(rules)
        }
      })
    },
    onSend(data) {
      //   this.$refs['send-form'].validate((valid, rules) => {
      //     if(valid) {
      this.sendFormData.content = data.content
      this.network().orderIssueIssuing('send')
    //     }
    //     else {
    //       console.log(rules)
    //     }
    //   })
    },
    onSkip() {
      this.network().orderIssueIssuing()
    },
    network() {
      return {
        orderIssueIssuing: async (type) => {
          let params = {
            order_id: this.orderId
          }
          if(this.form.product_id == 11) {
            if(this.formData.cvr_pdf) {
              params = {
                ...params,
                ...this.formData
              }
            }
          }
          const { data } = await orderIssueIssuing(params)

          if(type == 'send') {
            this.network().sendOrderIssueIssuingNotice()
          }
          else {
            this.dialog = false
            this.$emit('success')
          }
        },
        sendOrderIssueIssuingNotice: async () => {
          const { data } = await sendOrderIssueIssuingNotice({
            order_id: this.orderId,
            content: this.sendFormData.content
          })
          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      h3 {
        padding-bottom: 5px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: bold;
              font-size: 16px;
          }
      }
    }
</style>
